import { ElementOf, tuple } from './props';

export type ColorType = ElementOf<typeof ColorTypes>;

// https://github.com/PimpTrizkit/PJs
// https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)#stackoverflow-archive-begin
const pSBCr = (d: string): any => {
  const i = parseInt;
  let n = d.length,
    x: any = {};
  if (n > 9) {
    // @ts-ignore
    const [r, g, b, a] = (d = d.split(','));
    n = d.length;
    if (n < 3 || n > 4) return null;
    (x.r = i(r[3] == 'a' ? r.slice(5) : r.slice(4))),
      (x.g = i(g)),
      (x.b = i(b)),
      (x.a = a ? parseFloat(a) : -1);
  } else {
    if (n == 8 || n == 6 || n < 4) return null;
    if (n < 6)
      d =
        '#' +
        d[1] +
        d[1] +
        d[2] +
        d[2] +
        d[3] +
        d[3] +
        (n > 4 ? d[4] + d[4] : '');
    // @ts-ignore
    d = i(d.slice(1), 16);
    if (n == 9 || n == 5)
      // @ts-ignore
      (x.r = (d >> 24) & 255),
        // @ts-ignore
        (x.g = (d >> 16) & 255),
        // @ts-ignore
        (x.b = (d >> 8) & 255),
        // @ts-ignore
        (x.a = Math.round((d & 255) / 0.255) / 1000);
    // @ts-ignore
    else (x.r = d >> 16), (x.g = (d >> 8) & 255), (x.b = d & 255), (x.a = -1);
  }
  return x;
};

// https://github.com/PimpTrizkit/PJs
// https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)#stackoverflow-archive-begin
export const pSBC = (
  p: number,
  c0: string,
  c1?: string | boolean,
  l?: boolean
): string => {
  let r,
    g,
    b,
    P,
    f,
    t,
    h,
    m = Math.round,
    a = typeof c1 == 'string';
  if (
    typeof p != 'number' ||
    p < -1 ||
    p > 1 ||
    typeof c0 != 'string' ||
    (c0[0] != 'r' && c0[0] != '#') ||
    (c1 && !a)
  )
    return c0;
  (h = c0.length > 9),
    // @ts-ignore
    (h = a ? (c1.length > 9 ? true : c1 == 'c' ? !h : false) : h),
    (f = pSBCr(c0)),
    (P = p < 0),
    (t =
      c1 && c1 != 'c'
        ? // @ts-ignore
          pSBCr(c1)
        : P
        ? { r: 0, g: 0, b: 0, a: -1 }
        : { r: 255, g: 255, b: 255, a: -1 }),
    (p = P ? p * -1 : p),
    (P = 1 - p);
  if (!f || !t) return c0;
  if (l)
    (r = m(P * f.r + p * t.r)),
      (g = m(P * f.g + p * t.g)),
      (b = m(P * f.b + p * t.b));
  else
    (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
      (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
      (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
  (a = f.a),
    (t = t.a),
    // @ts-ignore
    (f = a >= 0 || t >= 0),
    // @ts-ignore
    (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
  if (h)
    return (
      'rgb' +
      (f ? 'a(' : '(') +
      r +
      ',' +
      g +
      ',' +
      b +
      // @ts-ignore
      (f ? ',' + m(a * 1000) / 1000 : '') +
      ')'
    );
  else
    return (
      '#' +
      // @ts-ignore
      (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0))
        .toString(16)
        .slice(1, f ? undefined : -2)
    );
};

export const getContrastYIQColor = (hexcolor: string) => {
  hexcolor = hexcolor.replace('#', '');
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 138 ? 'black' : 'white';
};

// 0 .. 255
export const getContrastYIQValue = (hexcolor: string) => {
  hexcolor = hexcolor.replace('#', '');
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq;
};

export type ColorDef = {
  bg: string;
  text: string;
  border: string;
};

export const colorsMap: {
  [key: string]: ColorDef;
} = {
  darkRed: { bg: '#F0DBDB', text: '#9E4242', border: '#E7C5C5' },
  orange: { bg: '#FFD7B2', text: '#B85800', border: '#FFD1A7' },
  magenta: { bg: '#EEDDEE', text: '#8A4287', border: '#E4C8E3' },
  purple: { bg: '#E3DDEE', text: '#7553AC', border: '#D3C8E4' },
  green: { bg: '#ABF3BB', text: '#0D8528', border: '#8DF0A3' },
  olive: { bg: '#DFF0BB', text: '#4E6D0E', border: '#D2EDA7' },
  teal: { bg: '#D0E9EF', text: '#2E798A', border: '#C2E3EB' },
  blue: { bg: '#D9E1F2', text: '#426CBD', border: '#C3D0EA' },
  navy: { bg: '#C6C8DB', text: '#232E9A', border: '#B7BAD9' },
  silverChalice: { bg: '#E4E4E4', text: '#616161', border: '#DDDDDD' },
  black: { bg: '#B7B7B7', text: '#000000', border: '#A6A6A6' },
};

export const colorsMapBadge: {
  [key: string]: ColorDef;
} = {
  darkRed: { bg: '#A14F5D', text: '#FFFFFF', border: '#A14F5D' },
  orange: { bg: '#EE8143', text: '#FFFFFF', border: '#EE8143' },
  magenta: { bg: '#C55BAD', text: '#FFFFFF', border: '#C55BAD' },
  purple: { bg: '#985BAF', text: '#FFFFFF', border: '#985BAF' },
  green: { bg: '#5CA26C', text: '#FFFFFF', border: '#5CA26C' },
  olive: { bg: '#83965C', text: '#FFFFFF', border: '#83965C' },
  teal: { bg: '#4F897B', text: '#FFFFFF', border: '#4F897B' },
  blue: { bg: '#369FDA', text: '#FFFFFF', border: '#369FDA' },
  navy: { bg: '#545DB5', text: '#FFFFFF', border: '#545DB5' },
  silverChalice: { bg: '#818181', text: '#FFFFFF', border: '#818181' },
  black: { bg: '#000000', text: '#FFFFFF', border: '#000000s' },
};
export const ColorTypes = tuple(
  'darkRed',
  'orange',
  'magenta',
  'purple',
  'green',
  'olive',
  'teal',
  'blue',
  'navy',
  'silverChalice',
  'black'
);

/*
--old colors

export const colorsMap: { [key: string]: string } = {
  IndianRed: '#CD5C5C',
  LightCoral: '#F08080',
  Salmon: '#FA8072',
  DarkSalmon: '#E9967A',
  Crimson: '#DC143C',
  Red: '#FF0000',
  FireBrick: '#B22222',
  DarkRed: '#8B0000',
  Pink: '#FFC0CB',
  LightPink: '#FFB6C1',
  HotPink: '#FF69B4',
  DeepPink: '#FF1493',
  MediumVioletRed: '#C71585',
  PaleVioletRed: '#DB7093',
  LightSalmon: '#FFA07A',
  Coral: '#FF7F50',
  Tomato: '#FF6347',
  OrangeRed: '#FF4500',
  DarkOrange: '#FF8C00',
  Orange: '#FFA500',
  Gold: '#FFD700',
  Yellow: '#FFFF00',
  LightYellow: '#FFFFE0',
  LemonChiffon: '#FFFACD',
  LightGoldenrodYellow: '#FAFAD2',
  PapayaWhip: '#FFEFD5',
  Moccasin: '#FFE4B5',
  PeachPuff: '#FFDAB9',
  PaleGoldenrod: '#EEE8AA',
  Khaki: '#F0E68C',
  DarkKhaki: '#BDB76B',
  Lavender: '#E6E6FA',
  Thistle: '#D8BFD8',
  Plum: '#DDA0DD',
  Violet: '#EE82EE',
  Orchid: '#DA70D6',
  Fuchsia: '#FF00FF',
  Magenta: '#FF00FF',
  MediumOrchid: '#BA55D3',
  MediumPurple: '#9370DB',
  RebeccaPurple: '#663399',
  BlueViolet: '#8A2BE2',
  DarkViolet: '#9400D3',
  DarkOrchid: '#9932CC',
  DarkMagenta: '#8B008B',
  Purple: '#800080',
  Indigo: '#4B0082',
  SlateBlue: '#6A5ACD',
  DarkSlateBlue: '#483D8B',
  MediumSlateBlue: '#7B68EE',
  GreenYellow: '#ADFF2F',
  Chartreuse: '#7FFF00',
  LawnGreen: '#7CFC00',
  Lime: '#00FF00',
  LimeGreen: '#32CD32',
  PaleGreen: '#98FB98',
  LightGreen: '#90EE90',
  MediumSpringGreen: '#00FA9A',
  SpringGreen: '#00FF7F',
  MediumSeaGreen: '#3CB371',
  SeaGreen: '#2E8B57',
  ForestGreen: '#228B22',
  Green: '#008000',
  DarkGreen: '#006400',
  YellowGreen: '#9ACD32',
  OliveDrab: '#6B8E23',
  Olive: '#808000',
  DarkOliveGreen: '#556B2F',
  MediumAquamarine: '#66CDAA',
  DarkSeaGreen: '#8FBC8B',
  LightSeaGreen: '#20B2AA',
  DarkCyan: '#008B8B',
  Teal: '#008080',
  Aqua: '#00FFFF',
  Cyan: '#00FFFF',
  LightCyan: '#E0FFFF',
  PaleTurquoise: '#AFEEEE',
  Aquamarine: '#7FFFD4',
  Turquoise: '#40E0D0',
  MediumTurquoise: '#48D1CC',
  DarkTurquoise: '#00CED1',
  CadetBlue: '#5F9EA0',
  SteelBlue: '#4682B4',
  LightSteelBlue: '#B0C4DE',
  PowderBlue: '#B0E0E6',
  LightBlue: '#ADD8E6',
  SkyBlue: '#87CEEB',
  LightSkyBlue: '#87CEFA',
  DeepSkyBlue: '#00BFFF',
  DodgerBlue: '#1E90FF',
  CornflowerBlue: '#6495ED',
  RoyalBlue: '#4169E1',
  Blue: '#0000FF',
  MediumBlue: '#0000CD',
  DarkBlue: '#00008B',
  Navy: '#000080',
  MidnightBlue: '#191970',
  Cornsilk: '#FFF8DC',
  BlanchedAlmond: '#FFEBCD',
  Bisque: '#FFE4C4',
  NavajoWhite: '#FFDEAD',
  Wheat: '#F5DEB3',
  BurlyWood: '#DEB887',
  Tan: '#D2B48C',
  RosyBrown: '#BC8F8F',
  SandyBrown: '#F4A460',
  Goldenrod: '#DAA520',
  DarkGoldenrod: '#B8860B',
  Peru: '#CD853F',
  Chocolate: '#D2691E',
  SaddleBrown: '#8B4513',
  Sienna: '#A0522D',
  Brown: '#A52A2A',
  Maroon: '#800000',
  White: '#FFFFFF',
  Snow: '#FFFAFA',
  HoneyDew: '#F0FFF0',
  MintCream: '#F5FFFA',
  Azure: '#F0FFFF',
  AliceBlue: '#F0F8FF',
  GhostWhite: '#F8F8FF',
  WhiteSmoke: '#F5F5F5',
  SeaShell: '#FFF5EE',
  Beige: '#F5F5DC',
  OldLace: '#FDF5E6',
  FloralWhite: '#FFFAF0',
  Ivory: '#FFFFF0',
  AntiqueWhite: '#FAEBD7',
  Linen: '#FAF0E6',
  LavenderBlush: '#FFF0F5',
  MistyRose: '#FFE4E1',
  Gainsboro: '#DCDCDC',
  LightGray: '#D3D3D3',
  Silver: '#C0C0C0',
  DarkGray: '#A9A9A9',
  Gray: '#808080',
  DimGray: '#696969',
  LightSlateGray: '#778899',
  SlateGray: '#708090',
  DarkSlateGray: '#2F4F4F',
  Black: '#000000',
};

export const ColorTypes = tuple(
  'IndianRed',
  'LightCoral',
  'Salmon',
  'DarkSalmon',
  'LightSalmon',
  'Crimson',
  'Red',
  'FireBrick',
  'DarkRed',
  'Pink',
  'LightPink',
  'HotPink',
  'DeepPink',
  'MediumVioletRed',
  'PaleVioletRed',
  'LightSalmon',
  'Coral',
  'Tomato',
  'OrangeRed',
  'DarkOrange',
  'Orange',
  'Gold',
  'Yellow',
  'LightYellow',
  'LemonChiffon',
  'LightGoldenrodYellow',
  'PapayaWhip',
  'Moccasin',
  'PeachPuff',
  'PaleGoldenrod',
  'Khaki',
  'DarkKhaki',
  'Lavender',
  'Thistle',
  'Plum',
  'Violet',
  'Orchid',
  'Fuchsia',
  'Magenta',
  'MediumOrchid',
  'MediumPurple',
  'RebeccaPurple',
  'BlueViolet',
  'DarkViolet',
  'DarkOrchid',
  'DarkMagenta',
  'Purple',
  'Indigo',
  'SlateBlue',
  'DarkSlateBlue',
  'MediumSlateBlue',
  'GreenYellow',
  'Chartreuse',
  'LawnGreen',
  'Lime',
  'LimeGreen',
  'PaleGreen',
  'LightGreen',
  'MediumSpringGreen',
  'SpringGreen',
  'MediumSeaGreen',
  'SeaGreen',
  'ForestGreen',
  'Green',
  'DarkGreen',
  'YellowGreen',
  'OliveDrab',
  'Olive',
  'DarkOliveGreen',
  'MediumAquamarine',
  'DarkSeaGreen',
  'LightSeaGreen',
  'DarkCyan',
  'Teal',
  'Aqua',
  'Cyan',
  'LightCyan',
  'PaleTurquoise',
  'Aquamarine',
  'Turquoise',
  'MediumTurquoise',
  'DarkTurquoise',
  'CadetBlue',
  'SteelBlue',
  'LightSteelBlue',
  'PowderBlue',
  'LightBlue',
  'SkyBlue',
  'LightSkyBlue',
  'DeepSkyBlue',
  'DodgerBlue',
  'CornflowerBlue',
  'MediumSlateBlue',
  'RoyalBlue',
  'Blue',
  'MediumBlue',
  'DarkBlue',
  'Navy',
  'MidnightBlue',
  'Cornsilk',
  'BlanchedAlmond',
  'Bisque',
  'NavajoWhite',
  'Wheat',
  'BurlyWood',
  'Tan',
  'RosyBrown',
  'SandyBrown',
  'Goldenrod',
  'DarkGoldenrod',
  'Peru',
  'Chocolate',
  'SaddleBrown',
  'Sienna',
  'Brown',
  'Maroon',
  'White',
  'Snow',
  'HoneyDew',
  'MintCream',
  'Azure',
  'AliceBlue',
  'GhostWhite',
  'WhiteSmoke',
  'SeaShell',
  'Beige',
  'OldLace',
  'FloralWhite',
  'Ivory',
  'AntiqueWhite',
  'Linen',
  'LavenderBlush',
  'MistyRose',
  'Gainsboro',
  'LightGray',
  'Silver',
  'DarkGray',
  'Gray',
  'DimGray',
  'LightSlateGray',
  'SlateGray',
  'DarkSlateGray',
  'Black'
);



 */
